import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import { useEventRsvpForm } from '../hooks/useEventRsvpForm';
import EventDetail from './EventDetail';
import EventDescription from './EventDescription';

const EventDisplay = ({ event }) => {
	const labels = useLabels();

	// Initialize RSVP form when event or labels change
	useEventRsvpForm(event, labels);

	// Function to convert ® symbol to superscript HTML
	const formatEventName = (eventName) => {
		if (!eventName) return '';
		// Replace ® with <sup>®</sup>
		return eventName.replace(/®/g, '<sup>®</sup>');
	};

	return (
		<div className="event-details-wrapper">
			{event.name && (
				<h1
					className="event-name"
					dangerouslySetInnerHTML={{
						__html: formatEventName(event.name)
					}}
				/>
			)}
			{event.bannerPath && (
				<img
					className="banner"
					src={event.bannerPath}
					alt={event.name || ''}
				/>
			)}
			<EventDetail
				startDate={event.startDate}
				endDate={event.endDate}
				time={event.time}
				location={event.location}
			/>
			<EventDescription className="retailer-description mt-5">
				{event.retailerDescription}
			</EventDescription>
			<EventDescription className="national-description mt-5">
				{event.nationalDescription}
			</EventDescription>
			<EventDescription className="text-muted align-center small">
				{event.disclaimer}
			</EventDescription>
		</div>
	);
};

export default EventDisplay;

const EventDisplayProp = {
	event: propTypes.shape({
		name: propTypes.string,
		bannerPath: propTypes.string,
		startDate: propTypes.string,
		endDate: propTypes.string,
		time: propTypes.string,
		location: propTypes.string,
		retailerDescription: propTypes.string,
		nationalDescription: propTypes.string,
		disclaimer: propTypes.string
	})
};

EventDisplay.propTypes = EventDisplayProp;
